import { makeStyles } from '@material-ui/styles';
import { darken } from '@material-ui/core/styles';
import { steelblue, } from 'styles/abstract/variables';

export const makeShipmentStyles = makeStyles({
    copyButton: {
        alignSelf: 'flex-start',
        color: steelblue,
        display: 'inline-flex',
        transition: 'all 0.3s ease',

        '&:hover': {
            color: darken(steelblue, 0.3),
            cursor: 'pointer',
        },
    },
    copyPanel: {
        display: 'flex',
        flexDirection: 'column',
    },
}, { index: 1 },);
